export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Date with time (isoformat) */
  DateTime: { input: any; output: any; }
};

export type FieldError = {
  __typename?: 'FieldError';
  /** error details */
  data: GenericErrorPositiveRangeDatetimeErrorLimitedValueError;
  /** the human readable message */
  message?: Maybe<Scalars['String']['output']>;
  /** path to the problematic field */
  path: Array<Scalars['String']['output']>;
};

export type GenericError = {
  __typename?: 'GenericError';
  /** the code of the error */
  key: ValueErrorType;
};

export type GenericErrorPositiveRangeDatetimeErrorLimitedValueError = GenericError | LimitedValueError | PositiveRangeDatetimeError;

/** An invitation for a meeting */
export type Invitation = {
  __typename?: 'Invitation';
  /** the participant will be called when the meeting starts (`phoneNumber` is required if true) */
  callout: Scalars['Boolean']['output'];
  /** the number of call out attempts left to try */
  calloutAttemptsLeft: Scalars['Int']['output'];
  /** an invitation email will be sent if provided */
  email?: Maybe<Scalars['String']['output']>;
  /** the ID of the invitation */
  id: Scalars['Int']['output'];
  /** shows if this invitation is auto generated */
  isAutoGenerated: Scalars['Boolean']['output'];
  /** the URL to use for joining the meeting with this invitation */
  joinUrl?: Maybe<Scalars['String']['output']>;
  meeting?: Maybe<Meeting>;
  /** the ID of the meeting this invitation belongs to */
  meetingId: Scalars['Int']['output'];
  /** the participant will be muted by default */
  muted: Scalars['Boolean']['output'];
  /** the name of the participant */
  name?: Maybe<Scalars['String']['output']>;
  /** this number will be called when the meeting starts if `callout` == true */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** require PIN code authentication when dialing in to the meeting */
  pinCodeRequired: Scalars['Boolean']['output'];
  type: InvitationType;
  userUri?: Maybe<Scalars['String']['output']>;
  /** the confidential identifier of the invitation */
  uuid: Scalars['String']['output'];
};

export type InvitationList = {
  __typename?: 'InvitationList';
  items: Array<Maybe<Invitation>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type InvitationMeetingInput = {
  /** the participant will be called when the meeting starts (`phoneNumber` is required if true) */
  callout: Scalars['Boolean']['input'];
  /** an invitation email will be sent if provided */
  email?: InputMaybe<Scalars['String']['input']>;
  /** the ID of the meeting */
  meetingId: Scalars['Int']['input'];
  /** the participant will be muted by default */
  muted: Scalars['Boolean']['input'];
  /** the name of the participant */
  name?: InputMaybe<Scalars['String']['input']>;
  /** this number will be called when the meeting starts if `callout` == true */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** require PIN code authentication when dialing in to the meeting */
  pinCodeRequired: Scalars['Boolean']['input'];
  /** the type of the inviation */
  type: InvitationType;
};

export enum InvitationType {
  Basic = 'BASIC',
  Host = 'HOST'
}

/** Error that indicates a value outside of the limit */
export type LimitedValueError = {
  __typename?: 'LimitedValueError';
  /** the code of the error */
  key: ValueErrorType;
  /** the value of the limit */
  limitValue: Scalars['Int']['output'];
};

export type Meeting = {
  __typename?: 'Meeting';
  /** allow participants to unmute themselves */
  allowUnmute: Scalars['Boolean']['output'];
  /** description of the meeting */
  description?: Maybe<Scalars['String']['output']>;
  /** the ID of the meeting */
  id: Scalars['Int']['output'];
  invitations: Array<Invitation>;
  /** length */
  length?: Maybe<Scalars['Int']['output']>;
  /** the SSO identifier of the owner */
  owner: Scalars['String']['output'];
  /** PIN code used when accessing the meeting through the IVR */
  pinCode?: Maybe<Scalars['String']['output']>;
  /** the room ID used in the IVR application */
  roomId: Scalars['String']['output'];
  /** the start time of the meeting */
  startTime: Scalars['DateTime']['output'];
  /** short summary of the meeting */
  summary: Scalars['String']['output'];
};

export type MeetingList = {
  __typename?: 'MeetingList';
  items: Array<Maybe<Meeting>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type Mutation = {
  __typename?: 'Mutation';
  /** Creates an invitation. */
  createInvitation: SaveResult;
  /** Deletes an invitation. */
  deleteInvitation: Array<FieldError>;
  /** Deletes a meeting. */
  deleteMeeting: Array<FieldError>;
  /** Ends a specific meeting. */
  endMeeting: Array<FieldError>;
  /** Creates or updates a meeting. */
  saveMeeting: SaveResult;
  /** Updates an invitation. */
  updateInvitation: Array<FieldError>;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationCreateInvitationArgs = {
  invitation: InvitationMeetingInput;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationDeleteInvitationArgs = {
  invitationId: Scalars['Int']['input'];
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationDeleteMeetingArgs = {
  meetingId: Scalars['Int']['input'];
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationEndMeetingArgs = {
  meetingId: Scalars['Int']['input'];
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationSaveMeetingArgs = {
  meeting: SaveMeetingInput;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationUpdateInvitationArgs = {
  invitation: UpdateInvitationInput;
};

/** Error that indicates a date outside of the specified range */
export type PositiveRangeDatetimeError = {
  __typename?: 'PositiveRangeDatetimeError';
  endField: Scalars['String']['output'];
  /** the code of the error */
  key: ValueErrorType;
  startField: Scalars['String']['output'];
};

/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type Query = {
  __typename?: 'Query';
  /** Returns an invitation list. */
  invitations?: Maybe<InvitationList>;
  /** Returns a meeting list. */
  meetings?: Maybe<MeetingList>;
  /** Returns the next meeting for the user. */
  nextMeeting?: Maybe<Meeting>;
  /** Returns `pong` if the server is available. */
  ping?: Maybe<Scalars['String']['output']>;
  /** Returns the roles of the user. */
  roles: Array<Role>;
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryInvitationsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  meetingId?: InputMaybe<Scalars['Int']['input']>;
  notId?: InputMaybe<Scalars['Int']['input']>;
  notMeetingId?: InputMaybe<Scalars['Int']['input']>;
  notUuid?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryMeetingsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  hideFuture?: InputMaybe<Scalars['Boolean']['input']>;
  hideStarted?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notId?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  ongoing?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Role = {
  __typename?: 'Role';
  name: Scalars['String']['output'];
  permissions: Array<Scalars['String']['output']>;
};

export type SaveInvitationInput = {
  /** the participant will be called when the meeting starts (`phoneNumber` is required if true) */
  callout: Scalars['Boolean']['input'];
  /** an invitation email will be sent if provided */
  email?: InputMaybe<Scalars['String']['input']>;
  /** the ID of the invitation */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** the participant will be muted by default */
  muted: Scalars['Boolean']['input'];
  /** the name of the participant */
  name?: InputMaybe<Scalars['String']['input']>;
  /** this number will be called when the meeting starts if `callout` == true */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** require PIN code authentication when dialing in to the meeting */
  pinCodeRequired: Scalars['Boolean']['input'];
  /** the type of the inviation */
  type: InvitationType;
};

export type SaveMeetingInput = {
  /** allow participants to unmute themselves */
  allowUnmute: Scalars['Boolean']['input'];
  /** description of the meeting */
  description?: InputMaybe<Scalars['String']['input']>;
  /** the ID of the meeting */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** invitations to add to the meeting */
  invitations?: Array<SaveInvitationInput>;
  /** the length of the meeting */
  length: Scalars['Int']['input'];
  /** PIN code used when accessing the meeting through the IVR */
  pinCode?: InputMaybe<Scalars['String']['input']>;
  /** the start time of the meeting */
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** short summary of the meeting */
  summary: Scalars['String']['input'];
};

export type SaveResult = {
  __typename?: 'SaveResult';
  errors?: Maybe<Array<FieldError>>;
  /** the ID of the saved record, set if the operation was successful */
  id?: Maybe<Scalars['Int']['output']>;
};

/** The schema’s entry-point for queries. This acts as the public, top-level API from which all subscription queries must start. */
export type Subscription = {
  __typename?: 'Subscription';
  /** Returns live data from meeting related invitations. */
  invitations: Array<Invitation>;
  /** Returns live data from a meeting. */
  meeting: Meeting;
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all subscription queries must start. */
export type SubscriptionInvitationsArgs = {
  meetingId: Scalars['Int']['input'];
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all subscription queries must start. */
export type SubscriptionMeetingArgs = {
  id: Scalars['Int']['input'];
};

export type UpdateInvitationInput = {
  /** the participant will be called when the meeting starts (`phoneNumber` is required if true) */
  callout: Scalars['Boolean']['input'];
  /** an invitation email will be sent if provided */
  email?: InputMaybe<Scalars['String']['input']>;
  /** the ID of the invitation */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** the participant will be muted by default */
  muted: Scalars['Boolean']['input'];
  /** the name of the participant */
  name?: InputMaybe<Scalars['String']['input']>;
  /** this number will be called when the meeting starts if `callout` == true */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** require PIN code authentication when dialing in to the meeting */
  pinCodeRequired: Scalars['Boolean']['input'];
  /** the type of the inviation */
  type: InvitationType;
};

export enum ValueErrorType {
  Email = 'EMAIL',
  FutureDate = 'FUTURE_DATE',
  MeetingNotInFuture = 'MEETING_NOT_IN_FUTURE',
  MeetingNotOngoing = 'MEETING_NOT_ONGOING',
  NotDeletable = 'NOT_DELETABLE',
  NotExists = 'NOT_EXISTS',
  OneOfEmailNamePhoneNumberRequired = 'ONE_OF_EMAIL_NAME_PHONE_NUMBER_REQUIRED',
  PhoneNumber = 'PHONE_NUMBER',
  PinCode = 'PIN_CODE',
  PositiveDateRange = 'POSITIVE_DATE_RANGE',
  PositiveNumber = 'POSITIVE_NUMBER',
  Required = 'REQUIRED',
  StringMinLength = 'STRING_MIN_LENGTH'
}
